import { Box } from "@mui/material";
import { DotLegalSearchField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import {
    listPageSearchFieldMaxWidth,
    listPageSearchFieldMinWidth,
    narrowListPageToolbarQuery,
} from "@common/components/listPageToolbar/ListPageToolbar.styles";

interface ListPageSearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
}

function ListPageSearchField(props: ListPageSearchFieldProps) {
    const { value, onChange, label } = props;
    const { translateString } = useTranslation();

    return (
        <Box
            sx={{
                width: listPageSearchFieldMaxWidth,
                flexShrink: 1,
                minWidth: listPageSearchFieldMinWidth,
                "& > :first-child": { minHeight: 38.5 },
                // A narrow toolbar gives the filters the full row, so the search takes all of it, like the view picker above
                [narrowListPageToolbarQuery]: { width: "100%" },
            }}
        >
            <DotLegalSearchField debounce useFullWidth labelSearch={label ?? translateString("search")} value={value} onChange={(v) => onChange(v ?? "")} />
        </Box>
    );
}

export default ListPageSearchField;
